<template>
  <div>
    <div class='tabs-container px-2 lg:px-8 pt-4 pb-2 border-b border-gray-100 text-gray-600'>
      <label
       :class='selectedStyle("ledger-code-edit")'
       class='mr-8 px-4 pb-2 pt-3 rounded-t cursor-pointer hover:bg-gray-100'>
        <input value='ledger-code-edit' v-model='view' type='radio' name='view' class='hidden'/>
        기본 코드 관리
      </label>
      <label
       :class='selectedStyle("portfolio-sectors")'
       class='mr-8 px-4 pb-2 pt-3 rounded-t cursor-pointer hover:bg-gray-100'>
        <input value='portfolio-sectors' v-model='view' type='radio' name='view' class='hidden'/>
        투자별 정보 관리
      </label>
    </div>
    <component :is='view' />
  </div>
</template>

<script>
import { RefreshIcon }       from '@vue-hero-icons/outline'
import LedgerCodeEdit        from '@/views/portfolio/LedgerCodeEdit.vue'
import PortfolioSectors      from '@/views/portfolio/PortfolioSectors.vue'

export default {
  name: 'LedgerCodes',
  components: {
    RefreshIcon,
    LedgerCodeEdit,
    PortfolioSectors,
  },
  data () {
    return {
      view: 'ledger-code-edit',
    }
  },
  methods: {
    selectedStyle (tab) {
      return (tab === this.view) ? 'text-gray-800 font-semibold border-b-2 border-gray-800' : 'border-b-2 border-transparent'
    }
  },
}
</script>
